import numeralFormatter, { NumeralFormats } from './numeralFormatter';

const numeralCellFormatter = ({ value }) =>
  numeralFormatter({ value, format: NumeralFormats.NUMBER_6_OPTIONAL_DECIMALS });

export default numeralCellFormatter;
